import React, { useRef, useState } from 'react';
import CreateAssignmentDialog from './CreateAssignmentDialog';
import { validateAssignmentForm } from '../../utils/assignments/assignments.helpers';
import { ASSIGNMENT_TYPE_META } from '../../utils/assignments/assignments.constants';

export default function EditAssignmentDialog({ assignment, onSave, onClose, ...props }) {
  const [draft, setDraft] = useState(() => ({ ...assignment, title: assignment.title || '', description: assignment.description || '',
    dueDate: assignment.dueDate || '', recipientIds: (assignment.recipientIds || []).map(String) }));
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const pending = useRef(false);
  async function save() {
    if (pending.current) return;
    const nextErrors = validateAssignmentForm(draft);
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;
    pending.current = true; setSaving(true);
    try {
      const result = await onSave(draft);
      if (result?.ok === false) setErrors({ submit: result.message || 'Salvataggio non riuscito.' });
      else onClose();
    } catch (cause) { setErrors({ submit: cause.message || 'Salvataggio non riuscito.' }); }
    finally { pending.current = false; setSaving(false); }
  }
  return <CreateAssignmentDialog {...props} mode="edit" assignment={assignment} newAssignment={draft}
    onOpenChange={open => { if (!open && !pending.current) onClose(); }}
    assignmentTypes={Object.entries(ASSIGNMENT_TYPE_META).map(([value, meta]) => ({ value, label: meta.label }))}
    formErrors={errors} creationWarning={errors.submit} isSubmitting={saving}
    onFieldChange={(field, value) => setDraft(previous => ({ ...previous, [field]: value }))} onSubmit={save} />;
}
